export default __webpack_public_path__ + "static/media/dot-menu.b9a32986.svg";